import { useState } from "react";
import "@/App.css";
import { useLenis } from "@/lib/useLenis";
import { Preloader } from "@/components/Preloader";
import { ScrollProgress } from "@/components/ScrollProgress";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { MarqueeBand } from "@/components/MarqueeBand";
import { DoctorChapter } from "@/components/DoctorChapter";
import { Services } from "@/components/Services";
import { CareFlow } from "@/components/CareFlow";
import { SpaceChapter } from "@/components/SpaceChapter";
import { Testimonials } from "@/components/Testimonials";
import { Consult } from "@/components/Consult";
import { Footer } from "@/components/Footer";

function App() {
    const [ready, setReady] = useState(false);
    useLenis();

    return (
        <div className="App grain" data-testid="app-root">
            <Preloader onDone={() => setReady(true)} />
            <ScrollProgress />
            <Nav />
            <main className="relative">
                <Hero />
                <MarqueeBand />
                <DoctorChapter />
                <Services />
                <CareFlow />
                <SpaceChapter />
                <Testimonials />
                <Consult />
            </main>
            <Footer />
        </div>
    );
}

export default App;
